import { FormEvent, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api';

export function ResetPage() {
  const [params] = useSearchParams();
  const token = params.get('token');

  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      if (token) {
        await api.confirmPasswordReset(token, newPassword);
      } else {
        await api.requestPasswordReset(email);
      }
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка');
    } finally {
      setSubmitting(false);
    }
  }

  if (done) {
    return (
      <div className="auth-container">
        <a className="auth-logo" href="/">
          <img src="/logo.png" alt="OrbanVPN" width="72" height="72" />
          <span className="brand-name">OrbanVPN</span>
        </a>
        <h1>{token ? 'Пароль обновлён' : 'Письмо отправлено'}</h1>
        <div className="card">
          <p>
            {token
              ? 'Теперь вы можете войти с новым паролем.'
              : 'Если такой email зарегистрирован, мы отправили ссылку для сброса пароля. Проверьте почту.'}
          </p>
          <Link to="/login" className="btn btn-block secondary" role="button">Перейти ко входу</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <a className="auth-logo" href="/">
        <img src="/logo.png" alt="OrbanVPN" width="72" height="72" />
        <span className="brand-name">OrbanVPN</span>
      </a>
      <h1>{token ? 'Новый пароль' : 'Сброс пароля'}</h1>
      <div className="card">
        <form onSubmit={onSubmit}>
          {token ? (
            <div className="form-row">
              <label htmlFor="newPassword">Новый пароль (мин. 10 символов)</label>
              <input id="newPassword" type="password" required minLength={10} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
            </div>
          ) : (
            <div className="form-row">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
          )}
          {error && <div className="error">{error}</div>}
          <button type="submit" className="btn-block" disabled={submitting}>{token ? 'Сменить пароль' : 'Прислать ссылку'}</button>
        </form>
      </div>
      <div className="auth-meta"><Link to="/login">Назад ко входу</Link></div>
    </div>
  );
}
